import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableRComponent } from './table-r.component';
import { UnilogNg9TableModule } from '@unilog/ng9-table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AngularSplitModule, SplitComponent } from 'angular-split';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [TableRComponent],

  imports: [
    CommonModule,
    FormsModule,
    UnilogNg9TableModule,
    FlexLayoutModule,
    MatBadgeModule,
    RouterModule,
    MatIconModule,
    AngularSplitModule,
  ],
  providers: [AngularSplitModule, SplitComponent],
  exports: [TableRComponent],
})
export class TableRModule {}
